import LessonSection from './LessonSection';

export default LessonSection;
